import { z } from 'zod';
import { nonEmptyText, optionalText } from './common';
import { createStepSchema, stepRequirementSchema } from './steps';

/**
 * Modelos de etapas: roteiros prontos (ex.: revisão sistemática) que o(a) orientador(a) aplica a um
 * trabalho, como estão ou personalizados. Cada etapa tem duração em dias, contada a partir do fim da
 * anterior; o prazo de cada uma é calculado na aplicação.
 */
export const templateStepSchema = z.object({
  title: nonEmptyText(200, 'Título'),
  description: optionalText(4000),
  durationDays: z.number().int().min(1, 'Mínimo de 1 dia').max(730, 'Máximo de 730 dias'),
  requirements: z.array(stepRequirementSchema).max(30, 'No máximo 30 comprovações por atividade').default([]),
});
export type TemplateStepInput = z.input<typeof templateStepSchema>;
export type TemplateStep = z.output<typeof templateStepSchema>;

const modalityKey = z.string().trim().min(1).max(40).regex(/^[A-Z0-9_]+$/, 'Tipo inválido');

export const stepTemplateInputSchema = z.object({
  name: nonEmptyText(120, 'Nome do modelo'),
  description: optionalText(1000),
  /** Tipos de trabalho em que o modelo aparece como sugestão. */
  modalityKeys: z.array(modalityKey).max(20).default([]),
  steps: z.array(templateStepSchema).min(1, 'Inclua ao menos uma atividade').max(30, 'No máximo 30 atividades'),
  /** Criar como modelo da plataforma (somente superadministração) */
  platform: z.boolean().default(false),
});
export type StepTemplateInput = z.input<typeof stepTemplateInputSchema>;
export type StepTemplateData = z.output<typeof stepTemplateInputSchema>;

/** Aplicação de um modelo (ou de várias etapas) a um trabalho, de uma só vez. */
export const createStepsBatchSchema = z.object({
  steps: z.array(createStepSchema).min(1, 'Escolha ao menos uma atividade').max(30, 'No máximo 30 atividades por vez'),
  /** Modelo de origem (para o histórico) */
  templateName: optionalText(120),
});
export type CreateStepsBatchInput = z.input<typeof createStepsBatchSchema>;
export type CreateStepsBatchData = z.output<typeof createStepsBatchSchema>;
